import React, { useEffect, useState } from "react";
import pic from "../assets/img/register/Frame 1.png";
import logo from "../assets/img/Logo/logo2.svg";
import call from "../assets/img/icons/call.svg";
import PhonNumber from "../components/layouts/register/PhonNumber";
import RegisterCommentBox from "../components/layouts/register/RegisterCommentBox";
import PhoneNumberConfirm from "../components/layouts/register/PhoneNumberConfirm";
import Signup from "../components/layouts/register/Signup";
import Button from "../components/shared/Button";
import { useNavigate } from "react-router-dom";


const Register = () => {

  const [step, setStep] = useState(1);
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState();
 

 
  return (
    <div className="Register">
      <div className="container">
        <div className="Register-container">
          <div className="Register--pic relative">
            <RegisterCommentBox />
          </div>
          <div className="Register--forms">
            <div className="flex justify-start">
              <img src={logo} />
            </div>
            <div>
              {step === 1
                ? <PhonNumber
                    phoneNumber={phoneNumber}
                    setPhoneNumber={setPhoneNumber}
                    setStep={setStep}
                  />
                : step === 2
                  ? <PhoneNumberConfirm
                      phoneNumber={phoneNumber}
                      setPhoneNumber={setPhoneNumber}
                      setStep={setStep}
                    />
                  : <Signup setStep={setStep} phoneNumber={phoneNumber} />}
            </div>
            <div className="flex items-center">
              <Button varient="fifth" onClick={() => navigate("/")}>
                برگشت به صفحه اصلی
              </Button>

              <button className="call-button mr-[34px]">
                <div className="flex items-center">
                  <img src={call} className="ml-[11px]" />
                  <p>+۹۸۲۱۲۵۸۳۵۸۹</p>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
